module.exports = __webpack_public_path__ + "img/menuSet.18254022.png";